import { filter } from 'rxjs/operators';

export const filterOutNulls = filter((x: any) => x);

export const createAscendingArray = (numItems: number) =>
  Array.from(Array(numItems).keys());
